document.addEventListener('DOMContentLoaded', function () {
  
  // 1. HERO BANNER SWIPER
  const initSwiper = setInterval(() => {
    if (typeof Swiper !== 'undefined') {
      clearInterval(initSwiper);
      const swiperContainer = document.querySelector('.hero-card-swiper');
      if (swiperContainer) {
        
        // THE FIX: Duplicate the slides in JS so the 3D stack never runs empty!
        const wrapper = swiperContainer.querySelector('.swiper-wrapper');
        const originalSlides = wrapper.innerHTML;
        wrapper.innerHTML = originalSlides + originalSlides + originalSlides;

        const autoPlayEnabled = swiperContainer.getAttribute('data-autoplay') === 'true';
        const autoPlaySpeed = parseInt(swiperContainer.getAttribute('data-speed')) || 5000;

        new Swiper('.hero-card-swiper', {
          effect: 'creative', 
          grabCursor: true,
          loop: true,
          navigation: {
            nextEl: '.hero-swiper-button-next',
            prevEl: '.hero-swiper-button-prev',
          },
          // REDUCED FROM 5 TO 2 TO SAVE CPU
          loopAdditionalSlides: 2, 
          watchSlidesProgress: true, 
          creativeEffect: {
            // REDUCED FROM 3 TO 2 TO LIMIT 3D MATH
            limitProgress: 2, 
            prev: { translate: ['-110%', 0, -400], rotate: [0, 0, -8], opacity: 0 },
            next: { translate: ['10%', 0, -80], rotate: [0, 0, 3] },
          },
          autoplay: autoPlayEnabled ? {
            delay: autoPlaySpeed,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          } : false,
        });
      }
    }
  }, 100);

  // 2. CURATED CAROUSEL SCROLL
  document.querySelectorAll('.curated-carousel-wrapper').forEach(function (wrapper) {
    const track = wrapper.querySelector('.curated-carousel-track');
    const prevBtn = wrapper.querySelector('.curated-nav-prev');
    const nextBtn = wrapper.querySelector('.curated-nav-next');
    const scrollAmount = 300;

    if (prevBtn) prevBtn.addEventListener('click', () => track.scrollBy({ left: -scrollAmount, behavior: 'smooth' }));
    if (nextBtn) nextBtn.addEventListener('click', () => track.scrollBy({ left: scrollAmount, behavior: 'smooth' }));
  });

  // 3. FAQ ACCORDION
  document.querySelectorAll('.faq-notebook-section .faq-sheet-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const answer = this.nextElementSibling;
      const isOpen = this.getAttribute('aria-expanded') === 'true';
      const section = this.closest('.faq-notebook-section');
      
      section.querySelectorAll('.faq-sheet-toggle').forEach(function (otherBtn) {
        otherBtn.setAttribute('aria-expanded', 'false');
        otherBtn.nextElementSibling.style.maxHeight = null;
      });

      if (!isOpen) {
        this.setAttribute('aria-expanded', 'true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

});